import type { ReactNode } from "react";
import type { ApiClientError } from "../../types/api";
import { ErrorMessage } from "../ErrorMessage";

interface RefusalSentenceProps {
  refusal: ApiClientError | null;
  onDismiss?: () => void;
  /** A control shown beside the sentence (a Confirm, a door), chosen by the caller. */
  children?: ReactNode;
}

/** A refusal shown by the server's sentence alone; the code is never rendered. */
export function RefusalSentence({ refusal, onDismiss, children }: RefusalSentenceProps): ReactNode {
  if (!refusal) return null;
  return (
    <div className="account-refusal">
      <ErrorMessage message={refusal.message} onDismiss={onDismiss} />
      {children}
    </div>
  );
}
